<div class="indicator fx-layout-col fx-justify-center fx-align-start" [ngClass]="icon">
  <div ref="eLabel" class="indicator-title">{{ 'LABEL.' + label | translate }}</div>
  <div ref="eValue" class="indicator-value">
    <span>{{ totalValue | fieldFormatType: formatType : currency }}</span>
    @if (suffix) {
      <span>{{ 'SUFFIX.' + suffix | uppercase | translate }}</span>
    }
  </div>
  @if (isAnyFilterPresent) {
    <div ref="eValue" class="indicator-value indicator-value-filtered">
      <span>{{ filteredValue | fieldFormatType: formatType : currency }}</span>
      @if (suffix) {
        <span>{{ 'SUFFIX.' + suffix | uppercase | translate }}</span>
      }
      <span> ({{ filteredValue - totalValue | fieldFormatType: formatType : currency }}</span>
      @if (suffix) {
        <span>{{ 'SUFFIX.' + suffix | uppercase | translate }}</span>
      }
      <span>) </span>
    </div>
  }
</div>
